import { Component, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { Form, FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { element } from 'protractor';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { AlertService } from '../../alertpopup/_alert';
export class MailData {
  MailBodyData: string;
  Subject: string;
}
export class InsertMailData {
  MailBodyData: string;
  Subject: string;
  MailID: string;
}

declare var $: any;
@Component({
    selector: 'app-editor',
    templateUrl: './editor.component.html',
    styleUrls: ['./editor.component.css'],
    standalone: false
})

export class EditorComponent implements OnInit  {
  FormemailEditor: FormGroup;
  FormSearchTemplate: FormGroup;
  model: any = {};
  Keyword: any;
  MailID: string;
  KeywordData: any;
  DisplayModule: any;
  DisplayFeature: any;
  textEditorData2: any;
  textEditorData: any;
  htmlContent = '';
  public TemplateType = "0"
  BranchId: string;
  LoggedInUserId: any;
  Template: any;
  yrsValue: string;
  PlaceHolder: string = "";
  name = 'Angular 6';
  url: string;
  htmlContent1 : string;
  DownloadURL: string;
  pageurl: string;
  pagehead: any;
  config1: AngularEditorConfig = {
    editable: true,
    spellcheck: true
};
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: false,
   
};
options = {
  autoClose: true,
  keepAfterRouteChange: false
};
typeList = [
  { id: '0', name: 'Alert' },
  { id: '1', name: 'Escalation' },
  { id: '2', name: 'Notification' }
];

alertModuleList = [
  { id: '3.1', name: 'Case' },
  { id: '3.2', name: 'Decision' },
  { id: '3.3', name: 'Notice' }
];

escalationModuleList = [
  { id: '4.1', name: 'Case' },
  { id: '4.2', name: 'Decision' },
  { id: '4.3', name: 'Diary' },
  { id: '4.4', name: 'Notice' }
];

notificationModuleList = [
  { id: '5.2', name: 'Case' },
  { id: '5.3', name: 'Decision' },
  { id: '5.4', name: 'Notice' }
];
featureList = [
  { label: 'Diary', value: 'M61' },
  { label: 'Level 1', value: 'M71' },
  { label: 'Level 2', value: 'M72' },
  { label: 'Level 3', value: 'M73' }
];
  from: any;

   constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, private sanitization: DomSanitizer, protected alertService: AlertService, private route : ActivatedRoute ) {
    this.url = AppComponent.baseURL;
    this.DownloadURL = AppComponent.DownloadURL;
  }

  ngOnInit() {
    this.pageurl = this.router.url;
    this.pagehead = this.pageurl.split('/');
    this.route.queryParams.subscribe(params => {
      this.from= params['from'];
      console.log(this.from);
    });
    if (this.pagehead[2] != 0) {
    this.ForGetKeyword(this.pagehead[2]); }
    this.FormSearchTemplate = this.formBuilder.group({
      SelectType: [''], KeyWordRecord: [''], SelectModuleAlert: [''], SelectModuleEscalation: [''], SelectModuleNotification: [''],
      SelectAlertDiary1: [''], SelectAlertDiary2: [''], SelectAlertDiary3: [''], SelectEscalationCase: [''], SelectEscalationDecision: [''],
      SelectEscalationDiary: [''], SelectEscalationNotice: [''], SelectNotificationAssign: [''], SelectNotificationCase: [''],
      SelectNotificationDecision: [''], SelectNotificationNotice: ['']
    });
    this.FormemailEditor = this.formBuilder.group ({
      textEditorData: [''] , textEditorData2: [''], Status: [''], KeyWordRecord: ['']});
    this.FormSearchTemplate.patchValue({
      SelectType: '0'
      });
    this.onTypeSelect(0);
  }

  SaveData(editorData) {
if(editorData.textEditorData2==""){ this.alertService.warn('Enter Mail Body Data',this.options);  return; }
if(editorData.textEditorData==""){ this.alertService.warn('Enter Subject of Email',this.options); return; }
let insertMailData: InsertMailData = {
      MailBodyData: editorData.textEditorData2,
      Subject: editorData.textEditorData,
      MailID: this.MailID
     };
this.http.post(this.url + 'EmailSchedular/insertUpdateMailFormat', insertMailData) .subscribe( (data) =>  {
            if (data == null) {
              this.alertService.error('Not Submitted',true);
            } else {
                this.alertService.success('Submitted',this.options);
            }
           }
         );
  }

  onTypeSelect(TypeID) {
    this.DisplayModule = TypeID; }

  onSelectModuleAlert(ModuleAlertValue) {
    this.DisplayFeature = ModuleAlertValue;
  }
  onSelectModuleEscalation(ModuleEscalationValue) {
    this.DisplayFeature = ModuleEscalationValue; }
    ForGetKeyword(KeyID) {
      this.MailID = KeyID;
      // tslint:disable-next-line: max-line-length
      if ( (KeyID == 'M61') || (KeyID == 'M62') || (KeyID == 'M63')  || (KeyID=='M77') || (KeyID=='M78') || (KeyID=='M79') || (KeyID=='M95') || (KeyID=='M97') || (KeyID == 'M99')) {
        this.Keyword = 303;
      }
      if ( (KeyID == 'M94') || (KeyID == 'M96') || (KeyID == 'M98') ) {
        this.Keyword = 304;
      }
      if ( (KeyID == 'M74') || (KeyID == 'M75') || (KeyID == 'M76')|| (KeyID == 'M21') || (KeyID == 'M22') || (KeyID == 'M23') || (KeyID == 'M92') || (KeyID == 'M41') || (KeyID == 'M42') || (KeyID == 'M43') ) {
        this.Keyword = 302;
      }
      // tslint:disable-next-line: max-line-length
      if ( (KeyID == 'M71') || (KeyID == 'M72') || (KeyID == 'M73') || (KeyID == 'M24') || (KeyID == 'M25') || (KeyID == 'M26') || (KeyID == 'M27') || (KeyID == 'M28') || (KeyID == 'M29') || (KeyID == 'M91') || (KeyID == 'M80') || (KeyID == 'M81') || (KeyID == 'M82') || (KeyID == 'M93' ) || (KeyID == 'M44' ) || (KeyID == 'M45' ) || (KeyID == 'M46' ) || (KeyID == 'M47' ) || (KeyID == 'M48' ) || (KeyID == 'M49' )){
        this.Keyword = 301;
      }
      if ( (KeyID == 'M88') || (KeyID == 'M89') || (KeyID == 'M90') ) {
        this.Keyword = 305;
      }
      this.http.get(this.url + 'EmailSchedular/Get_Keywrod_for_email?ID=' + this.Keyword+'&TemplateID='+KeyID)
      .subscribe( (data) =>   {
          if (data == null) {
            this.KeywordData = null;
          } else {
            this.KeywordData = JSON.parse(data.toString());
          }
         }
      );
      this.http.get(this.url + 'EmailSchedular/Fetch_Mail_Template?MailID=' +KeyID)
      .subscribe( (data) =>   {
          if (data == null) {
            //this.KeywordData = null;
          } else {
            console.log(data);
            const mailData: MailData = JSON.parse(data.toString());
            console.log(mailData.MailBodyData);
            this.FormemailEditor.patchValue({
              textEditorData: mailData.Subject, textEditorData2: mailData.MailBodyData
              });

          }
         }
      );
    }
  onSelectModuleNotification(ModuleNotificationValue) {
    this.DisplayFeature = ModuleNotificationValue; }

  onStatusSelect(text) {
    var sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
            var range = sel.getRangeAt(0);
            range.insertNode(document.createTextNode('[' + text + ']'));
         //  range.insertNode(range.startContainer);
         range.insertNode(document.createTextNode(' '));
         console.log(range);
        }
  }

  goBack(){
    if(this.from=='notification'){
      this.router.navigate(['/notification']);
      return;
    }else{
      this.router.navigate(['/escalation']);
    }
  }
}


